/* global $:false */

export default class AppNavigationBridge {
  static init () {
    Array.from($('.t-ios-app')).map((el) =>
      new AppNavigationBridge(el))
  }

  constructor (el) {
    this.checkAppContext()
    if (this.inAppContext) {
      this.findElements()
      this.setupVariables()
      this.callOut()
    }
  }

  checkAppContext() {
    if (window.webkit?.messageHandlers?.htmxNavigation) {
      this.inAppContext = true
    }
    else {
      this.inAppContext = false
    }
  }

  findElements() {
    this.dataLayerElement = $('.js-data-layer')
    this.appInteropElement = $('.js-app-interop')
  }

  setupVariables() {
    this.itemId = this.dataLayerElement.data('item-id')
    this.appPageTitle = this.appInteropElement.data('app-page-title')
  }

  callOut() {
    window.webkit.messageHandlers.htmxNavigation.postMessage({
      'path': window.location.pathname,
      'title': this.appPageTitle,
      'itemId': this.itemId
    })
  }
}
